import { useHead, type HeadTag } from "@/lib/head";

interface SEOProps {
  title: string;
  description: string;
  ogImage?: string;
  canonical?: string;
  type?: "website" | "article" | "product";
}

const SEO = ({
  title,
  description,
  ogImage = "https://rubinimagione.it/og-image.jpg",
  canonical,
  type = "website",
}: SEOProps) => {
  const siteUrl = "https://rubinimagione.it";
  const fullTitle = `${title} | Mangimi Rubini`;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  const tags: HeadTag[] = [
    { tag: "title", text: fullTitle },
    { tag: "meta", name: "description", content: description },
    { tag: "link", rel: "canonical", href: canonicalUrl },

    { tag: "meta", property: "og:type", content: type },
    { tag: "meta", property: "og:title", content: fullTitle },
    { tag: "meta", property: "og:description", content: description },
    { tag: "meta", property: "og:image", content: ogImage },
    { tag: "meta", property: "og:url", content: canonicalUrl },
    { tag: "meta", property: "og:locale", content: "it_IT" },
    { tag: "meta", property: "og:site_name", content: "Mangimi Rubini" },

    { tag: "meta", name: "twitter:card", content: "summary_large_image" },
    { tag: "meta", name: "twitter:title", content: fullTitle },
    { tag: "meta", name: "twitter:description", content: description },
    { tag: "meta", name: "twitter:image", content: ogImage },
  ];

  useHead("seo", tags);
  return null;
};

export default SEO;
